import { PriceRange } from '../../../services/products/payload/product-poi-payload';
import { DisplayLabel, ProductDisplayLabel } from '../product-detail-info.model';
/* ---------------- LV.C ---------------- */
// --------- Hotel List Request --------- //
export class HotelListRequest {
    langId: number;
    companyId: number;
    currencyId: number;
    destinationId?: number;
    productIds?: number[] = [];
    checkIn: string;
    checkOut: string;
    roomRequests?: HotelListRoomRequest[] = [];
    pagination?: HotelListPagination;
    sort?: HotelListSort;
    purpose: string;
    filterRequest?: HotelListFilter;
    coordinates?: GeoPolygon;
    allowOverBudget?= false;
    shareBudgetCode?: string;
    exclude?: HotelListExclude;
    muBirthdateNo: number;
}

export class HotelListRoomRequest {
    adultAmount: number;
    children: number[] = [];

    constructor(adultAmount?: number, children: number[] = []) {
        this.adultAmount = adultAmount;
        this.children = children;
    }
}

export class HotelListPagination {
    itemPerPage: number;
    pageNo: number;
    constructor(itemPerPage: number, pageNo: number) {
        this.itemPerPage = itemPerPage;
        this.pageNo = pageNo;
    }
}

export class HotelListSort {
    sortBy: string;
    sortDir?: string;
    constructor(sortBy: string, sortDir: string) {
        this.sortBy = sortBy;
        this.sortDir = sortDir;
    }
}

export class HotelListFilter {
    distance: number;
    priceRange?: PriceRange = null;
    reviewScore?: number;
    facilities?: string[] = [];
    hotelStars?: number[] = [];
    locations?: HotelListLocation[] = [];
    muTravelTypes?: string[] = [];
    includeBreakfast = false;
    includeSecurityStandard = false;
    includeSanitizedStay = false;
    includeFreeCancellation = false;
}

export class HotelListLocation {
    locationId: number;
    polygon: GeoPolygon[] = [];

}

export class GeoPolygon {
    lat: number;
    lon: number;

    constructor(lat: number, lon: number) {
        this.lat = lat;
        this.lon = lon;
    }
}

// -------- Hotel List Response -------- //
export class HotelListResponse {
    totalItems: number;
    currencyCode: string;
    items: CheapestRoom[] = [];
    locations: HotelListLocaltionResponse[] = [];
    facilities: HotelListFacilityResponse[] = [];
    hotelStar: HotelStarResponse;
    normalBudget: number;
    allowLimitBudget: boolean;
    companyTravelPolicyUserResponse: CompanyTravelPolicyUserResponse[] = [];
    priceRange?: PriceRange;
}

export class CheapestRoom {
    destinationId?: number;
    allotment: number;
    netPrice: number;
    totalPrice: number;
    payOn?: string;
    lastDayCancel?: string;
    productId?: number;
    latitude: number;
    longitude: number;
    hotelStar?: number;
    imageUrl: string;
    distance?: number;
    slug?: string;
    reviewRatingScore?: number;
    reviewRatingTitle?: string;
    totalScore?: number;
    productTitle: string;
    address: string;
    facilityIcons: HotelListFacilityIcon[] = [];
    overBudget: number;
    budget: number;
    currencyCode?: string;
    overPrice?: number;
    displaySanitation?: boolean;
    displayLabels?: DisplayLabel[] = [];
    promotion?: HotelPromotion;
    type?: string;
    campaignRankingAds?: CampaignRankAds;
    muTravelTypes: PositiveEnergy[];

    constructor(data: CheapestRoom) {
        this.allotment = data.allotment;
        this.netPrice = data.netPrice;
        this.totalPrice = data.totalPrice;
        this.payOn = data.payOn;
        this.lastDayCancel = data.lastDayCancel;
        this.productId = data.productId;
        this.latitude = data.latitude;
        this.longitude = data.longitude;
        this.hotelStar = data.hotelStar;
        this.imageUrl = data.imageUrl;
        this.slug = data.slug;
        this.reviewRatingScore = data.reviewRatingScore;
        this.totalScore = data.totalScore;
        this.productTitle = data.productTitle;
        this.address = data.address;
        this.facilityIcons = [...data.facilityIcons];
        this.reviewRatingTitle = data.reviewRatingTitle;
        this.overPrice = data.overPrice;
        this.currencyCode = data.currencyCode;
        this.distance = data.distance;
        this.displaySanitation = data.displaySanitation;
        this.displayLabels = data.displayLabels;
        this.promotion = data.promotion;
        this.campaignRankingAds = data.campaignRankingAds;
        this.muTravelTypes = data.muTravelTypes;
    }
}

export class PositiveEnergy {
    name: string;
    displayName: string;
}

export class CampaignRankAds {
    campaignId: number;
    category: string;
}

export class HotelListLocaltionResponse {
    locationId: number;
    locationName: string;
    polygon: GeoPolygon[] = [];
}
export class HotelListFacilityResponse {
    key?: string;
    title: string;
    hotelCount: number;
    selected?= false;
}
export class HotelStarResponse {
    noStarHotelCount: number;
    oneStarHotelCount: number;
    twoStarHotelCount: number;
    threeStarHotelCount: number;
    fourStarHotelCount: number;
    fiveStarHotelCount: number;
}

export class HotelListFacilityIcon {
    icon: string;
    title: string;
}

export class HotelStarFilter {
    star: number;
    hotelCount: number;
    selected?= false;
    displayStar: string;
}

export class HotelListPriceRangeResponse {
    minPrice: number;
    maxPrice: number;

    constructor(minPrice?: number, maxPrice?: number) {
        this.minPrice = minPrice;
        this.maxPrice = maxPrice;
    }
}

export class HotelListSortType {
    public static readonly RECOMMEND = 'recommend';
    public static readonly NAME_TYPE = 'name';
    public static readonly PRICE = 'price';
    public static readonly REVIEW_RATING = 'reviewRating';
    public static readonly HOTEL_STAR = 'hotelStar';
    public static readonly POI_DISTANCE = 'distance';
}

export class DestinationTravelPolicy {
    destinationId: number;
    destinationNameEn: string;
    destinationNameTh: string;
    averageBudget: number;
    totalBudget: number;
    appliedCoBudget: boolean;
    travelPolicyList: TravelPolicy[];
}

export class TravelPolicy {
    policyId: number;
    policyName: string;
    date: string;
    budgetType: string;
    budget: string;
    totalBudget: number;
    totalBudgetType: string;
}

export class CompanyTravelPolicyUserResponse {
    userId: number;
    companyId: number;
    allowLimitBudget: boolean;
    normalBudget: number;
    normalBudgetUnlimited: boolean;
    normalCoBudget: number;
    normalCoBudgetUnlimited: boolean;
    destinationTravelPolicyList: DestinationTravelPolicy[];
}

export class HotelPromotion {
    promotionType: string;
    discount?: number;
    discountType?: string;
}

export class HotelPromotionPromotionType {
    public static readonly LAST_MINUTE = 'last_minute';
    public static readonly SPECIAL_PRICE = 'special_price';
}

export class HotelPromotionDiscountType {
    public static readonly PERCENT = 'percent';
    public static readonly AMOUNT = 'amount';
}

export class HotelListExclude {
    hotelIds: number[];
}



// WEBPACK FOOTER //
// ./src/app/model/products/hotel/hotel.model.ts